import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface usePreviousCompletedObservationsOptions {
	observationInstanceId?: number | null;
	year?: number;
}

const fetchPreviousCompletedObservation = async ({
	observationInstanceId,
	year
}: usePreviousCompletedObservationsOptions) => {
	const url = `/observations/instances/${observationInstanceId}/previous/`;
	const response = await cmsClient.get<number[]>(url, {
		params: {
			year
		}
	});

	return response.data;
};

interface Options {
	enabled: boolean;
	onSuccess?: (data: number[]) => void;
}

const usePreviousCompletedObservations = (
	{ observationInstanceId, year }: usePreviousCompletedObservationsOptions,
	options: Options = { enabled: true }
) => {
	const query = useQuery(
		["completedObservationForms", { observationInstanceId, year }],
		() => fetchPreviousCompletedObservation({ observationInstanceId, year }),
		options
	);

	return query;
};

export default usePreviousCompletedObservations;
